import { createAction, props } from '@ngrx/store';

export const SET_SNACK_BAR = '[snack bar] Set';
export const setSnackBar = createAction(
  SET_SNACK_BAR,
  props<{ snackBarSuccess: boolean; showSnackBar: boolean; snackBarMessage: string }>()
);
